// Resolves the URL for any CTA based on global cta config + WhatsApp fallback
export function resolveCtaUrl(content, overrideUrl) {
  if (overrideUrl) return overrideUrl;
  const target = content?.cta?.target || "sales";
  if (target === "sales" && content?.cta?.salesUrl) {
    return content.cta.salesUrl;
  }
  // Fallback to WhatsApp
  const num = (content?.whatsapp?.number || "").replace(/\D/g, "");
  const msg = encodeURIComponent(content?.whatsapp?.message || "");
  return `https://wa.me/${num}?text=${msg}`;
}

export function waLink(whatsapp) {
  const num = (whatsapp?.number || "").replace(/\D/g, "");
  const msg = encodeURIComponent(whatsapp?.message || "");
  return `https://wa.me/${num}?text=${msg}`;
}

// File URL helper: backend serves uploads at /api/files; prefix with REACT_APP_BACKEND_URL when relative
export function fileUrl(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
